var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHongKong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12.825 6.05c-.18.75-.502.615-.66 1.275a1.74 1.74 0 11.81-3.382c-.315 1.32.015 1.432-.15 2.107zm-2.422.563c.66.405.427.667 1.005 1.02a1.753 1.753 0 01-3-1.815c1.192.682 1.402.427 1.995.795zm-.218 2.475c.592-.503.75-.195 1.282-.638a1.741 1.741 0 11-2.64 2.25c1.028-.87.833-1.155 1.358-1.612zm2.295.975c-.3-.75.045-.795-.218-1.418a1.74 1.74 0 011.335 3.21c-.517-1.253-.847-1.148-1.117-1.793zm1.627-1.883c-.75.068-.75-.285-1.417-.232a1.742 1.742 0 113.473-.278c-1.358.113-1.366.458-2.056.51z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHongKong);
export default __webpack_public_path__ + "static/media/HongKong.f969f82e0ea407b98b9c5d628e6594bb.svg";
export { ForwardRef as ReactComponent };